import { IOption } from "../../../../types";
import { NavItem } from "../../../../types/types.navigation";
import {
  IconFavorite,
  IconFavoriteBorder,
  IconButton,
  BUTTON_SIZES,
  CardGroup,
} from "@cdkglobal/radial";
import {
  CardRowStyled,
  DepartmentLabel,
  StyledSetupCardWrapper,
  SetupsCardRowWrapper,
  StyledInfoCard,
  SetupDescription,
  SetupTitle,
} from "../../../../utils/styled";
import { ampli } from "../../../../ampli";

interface SetupCardContentProps {
  setupItems: NavItem[];
  handleSetupClick: (params: { setup: IOption; department: IOption }) => void;
  favorites: NavItem[];
  toggleFavorite: (setup: NavItem) => void;
}

const SetupCardItem = ({
  setupItem,
  favorites,
  toggleFavorite,
  handleSetupClick,
}: {
  setupItem: NavItem;
  favorites: NavItem[];
  toggleFavorite: (setup: NavItem) => void;
  handleSetupClick: (params: { setup: IOption; department: IOption }) => void;
}) => {
  const isFavorite = favorites?.some((f) => f.id === setupItem.id);

  if (setupItem.isDisabled) {
    return <InfoCard infoText={setupItem.text} />;
  }

  return (
    <StyledSetupCardWrapper
      dataTestId={`${setupItem.id}-setup-card`}
      onClick={() => {
        ampli.openSetup({
          "Setup Name": setupItem.text,
          Department: setupItem.department?.label,
          "Is Favorite": isFavorite,
        });

        handleSetupClick({
          setup: {
            label: setupItem.text,
            value: setupItem.id,
          },
          department: setupItem.department as IOption,
        });
      }}
    >
      <SetupTitle>{setupItem.text}</SetupTitle>
      <SetupDescription>{setupItem.description}</SetupDescription>

      <CardRowStyled>
        <CardGroup>
          <DepartmentLabel>{setupItem.department?.label}</DepartmentLabel>
        </CardGroup>

        <CardGroup>
          <IconButton
            dataTestId={`${setupItem.id}-favorite-button`}
            icon={isFavorite ? <IconFavorite /> : <IconFavoriteBorder />}
            iconColor="gray"
            size={BUTTON_SIZES.SMALL}
            text="favorite"
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
              toggleFavorite(setupItem);
            }}
          />
        </CardGroup>
      </CardRowStyled>
    </StyledSetupCardWrapper>
  );
};

export const SetupCardContent = ({
  setupItems,
  handleSetupClick,
  favorites,
  toggleFavorite,
}: SetupCardContentProps): JSX.Element => {
  if (setupItems.length === 0) {
    return <InfoCard infoText="No Results." />;
  }

  return (
    <SetupsCardRowWrapper>
      {setupItems.map((setupItem) => (
        <SetupCardItem
          key={setupItem.id}
          setupItem={setupItem}
          favorites={favorites}
          toggleFavorite={toggleFavorite}
          handleSetupClick={handleSetupClick}
        />
      ))}
    </SetupsCardRowWrapper>
  );
};

export const InfoCard = ({ infoText }: { infoText: string }): JSX.Element => {
  return (
    <StyledInfoCard>
      <h5>{infoText}</h5>
    </StyledInfoCard>
  );
};
